import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert, Button,
} from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import {
  Box, Flex, ShowIf, Text,
} from '../../shared/components';

import BackgroundColorContainer from '../components/other/BackgroundColorContainer';

import {
  actualizarOpcionesCanalRequest,
} from '../../../state/actions/creators/giotalk.actioncreator';
import SubscripcionToggleList from '../components/dataDisplay/SubscripcionToggleList';
import { obtenerEstadoRequestDesdeSaga } from '../../../helpers/sagaStatus.helper';

class GIOTalkOpcionesPage extends React.Component {
  componentDidMount() {
    this.clonarOpcionesEnComponente();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps && nextProps.estadoPeticionActualizar) {
      const { estadoPeticionActualizar } = nextProps;
      const { running, success } = estadoPeticionActualizar;
      if (running === false && success === false) {
        const { canal } = this.props;
        const { subscripciones } = canal;
        this.setState({ subscripciones });
      }
    }
  }

  clonarOpcionesEnComponente() {
    const noHayEstadoActual = this.state === null;
    this.setState({ subscripciones: [] });
    if (noHayEstadoActual) {
      const { canal } = this.props;
      if (canal !== undefined && canal !== null) {
        const { subscripciones } = canal;
        this.setState({ subscripciones });
      }
    }
  }

  switchChangeEvent({ value, id }) {
    const { subscripciones } = this.state;
    const subscripcionesModificadas = subscripciones.map((subscripcion) => {
      const { subId: subscripcionId } = subscripcion;
      if (subscripcionId === id) {
        return {
          ...subscripcion,
          usuarioActiva: value,
        };
      }
      return subscripcion;
    });
    this.setState({ subscripciones: subscripcionesModificadas });
  }

  actualizarOpciones() {
    const { subscripciones } = this.state;
    const { actualizarOpcionesCanalRequest, canal: { id: canalId } } = this.props;
    actualizarOpcionesCanalRequest({ canalId, opciones: { subscripciones } });
  }

  render() {
    const { history, canal } = this.props;
    const { estadoPeticionActualizar: { running: disableRequests, success: peticionActualizarExitosa } } = this.props;

    if (canal === undefined) {
      return <div />;
    }
    const { subscripciones } = this.state || { subscripciones: [] };
    const { nombre } = canal;
    const title = `Subscripciones de ${nombre}`;
    let numeroActivas = 0;
    subscripciones.forEach((subscripcion) => {
      const { usuarioActiva } = subscripcion;
      if (usuarioActiva === true) numeroActivas += 1;
    });
    const textoTotalActivas = `${numeroActivas} activas`;

    const header = (
      <Box style={{ borderBottom: '1px solid #1d586f' }} pb="16">
        <Box>
          <Button
            onClick={() => history.goBack()}
            style={{ padding: 0 }}
            type="link"
            ghost
          >
            <FontAwesomeIcon style={{ marginBottom: '3px' }} icon={faArrowLeft} color="lightgrey" />
          </Button>
          <Text ml="8" fontSize="24" color="white">{title}</Text>
        </Box>
        <Box mt="4">
          <Text fontSize="12" color="white">{textoTotalActivas}</Text>
        </Box>
      </Box>
    );

    const content = (
      <Box>
        <ShowIf condition={peticionActualizarExitosa === false && disableRequests === false}>
          <Box pt="16" pb="16">
            <Alert type="error" message="Ha ocurrido un problema a la hora de guardar" />
          </Box>
        </ShowIf>
        <SubscripcionToggleList
          disabled={disableRequests}
          onChange={event => this.switchChangeEvent(event)}
          subscripciones={subscripciones}
        />
      </Box>
    );

    const footer = (
      <Box style={{ borderTop: '1px solid #1d586f' }} mt="16" pt="16">
        <Flex justifyContent="space-between">
          <Box />
          <Box>
            <Box display="inline-block" mr="8">
              <Button onClick={() => history.goBack()}>Cancelar</Button>
            </Box>
            <Box display="inline-block">
              <Button
                loading={disableRequests}
                type="primary"
                onClick={() => this.actualizarOpciones()}
              >
                Guardar
              </Button>
            </Box>
          </Box>
        </Flex>
      </Box>
    );

    return (
      <BackgroundColorContainer color="#063340">
        <Box p="16">
          {header}
          {content}
          {footer}
        </Box>
      </BackgroundColorContainer>
    );
  }
}

GIOTalkOpcionesPage.propTypes = {
  actualizarOpcionesCanalRequest: PropTypes.func.isRequired,
  canal: PropTypes.shape({
    descripcion: PropTypes.any.isRequired,
    id: PropTypes.number.isRequired,
    nombre: PropTypes.any.isRequired,
    opciones: PropTypes.object.isRequired,
  }).isRequired,
  estadoPeticionActualizar: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const { sagas } = state;
  const { giotalk: { notificaciones } } = state;
  return {
    canal: notificaciones,
    estadoPeticionActualizar: obtenerEstadoRequestDesdeSaga(sagas, 'GIOTALK_CHANNEL_SETTINGS_UPDATE'),
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    actualizarOpcionesCanalRequest,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GIOTalkOpcionesPage);
